import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    deleteDoc,
    query,
    setDoc,
    where,
    limit, orderBy
} from "firebase/firestore";
import Promise from "bluebird";
import _ from "lodash";
import {fireStoreDB} from "../../firebase/client-app";

export {
    addShopifyCollections,
    addSingleShopifyCollection,
    updateShopifyCollections,
    updateSingleShopifyCollection,
    deleteSingleShopifyCollection,
    getSingleShopifyCollection,
    searchShopifyCollections,
    prepareShopifyCollectionsList
}

const collectionName = 'shopify-collections';
const collectionReference = collection(fireStoreDB, collectionName);

const addShopifyCollections = (shopifyCollections) => {
    return Promise.map(shopifyCollections, async shopifyCollection => {
        console.log('.');
        await addSingleShopifyCollection(shopifyCollection);
    });
}

const updateShopifyCollections = (shopifyCollections) => {
    return Promise.map(shopifyCollections, async shopifyCollection => {
        console.log('.');
        await updateSingleShopifyCollection(shopifyCollection);
    });
}

const addSingleShopifyCollection = (shopifyCollection) => {
    return addDoc(collectionReference, shopifyCollection);
}

const updateSingleShopifyCollection = (shopifyCollection) => {
    const documentReference = doc(fireStoreDB, collectionName, shopifyCollection.id);
    return setDoc(documentReference, shopifyCollection);
}

const deleteSingleShopifyCollection = (shopifyCollection) => {
    const documentReference = doc(fireStoreDB, collectionName, shopifyCollection.id);
    return deleteDoc(documentReference);
}

const getSingleShopifyCollection = (shopifyCollectionId) => {
    const documentReference = doc(fireStoreDB, collectionName, shopifyCollectionId);
    return getDoc(documentReference);
}

const searchShopifyCollections = async (searchCriteriaList) => {
    let searchQuery = query(collectionReference);

    // searchQuery = query(searchQuery, orderBy('updatedAt', 'desc'));

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    searchQuery = query(searchQuery,
        limit(200));

    const shopifyCollectionResult = await getDocs(searchQuery);
    return prepareShopifyCollectionsList(shopifyCollectionResult);
}

const prepareShopifyCollectionsList = (shopifyCollectionResult) => {
    const shopifyCollectionsList = [];

    _.forEach(shopifyCollectionResult.docs, shopifyCollectionDoc => {
        shopifyCollectionsList.push({
            ...shopifyCollectionDoc.data(),
            id: shopifyCollectionDoc.id
        });
    });

    return shopifyCollectionsList;
}
